import React from 'react';
import Icon from '../../../components/AppIcon';

const MedicalHistorySection = ({ history = [] }) => {
  const getCategoryIcon = (category) => {
    switch (category) {
      case 'diagnosis':
        return 'Stethoscope';
      case 'surgery':
        return 'Scissors';
      case 'allergy':
        return 'AlertTriangle';
      case 'medication':
        return 'Pill';
      default:
        return 'FileText';
    }
  };

  const getCategoryColor = (category) => {
    switch (category) {
      case 'diagnosis':
        return 'text-primary';
      case 'surgery':
        return 'text-destructive';
      case 'allergy':
        return 'text-warning';
      case 'medication':
        return 'text-secondary';
      default:
        return 'text-muted-foreground';
    }
  };

  if (history?.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
        <div className="flex items-center justify-center w-16 h-16 bg-muted rounded-full mb-4">
          <Icon name="FileText" size={32} color="var(--color-muted-foreground)" />
        </div>
        <p className="text-base font-medium text-foreground mb-2">No Medical History</p>
        <p className="text-sm text-muted-foreground">Patient medical history will appear here</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {history?.map((item) => (
        <div
          key={item?.id}
          className="bg-card border border-border rounded-lg p-4 md:p-5 lg:p-6 transition-smooth hover:shadow-elevation-2"
        >
          <div className="flex items-start gap-3 md:gap-4">
            <div className={`flex-shrink-0 ${getCategoryColor(item?.category)}`}>
              <Icon name={getCategoryIcon(item?.category)} size={24} />
            </div>
            
            <div className="flex-1 min-w-0">
              <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2 mb-2">
                <h4 className="text-base md:text-lg font-semibold text-foreground">{item?.condition}</h4>
                <span className="text-xs md:text-sm text-muted-foreground whitespace-nowrap">
                  {item?.date}
                </span>
              </div>
              
              {item?.icdCode && (
                <div className="inline-flex items-center gap-2 px-3 py-1 bg-muted rounded-md mb-3">
                  <Icon name="Hash" size={14} />
                  <span className="text-xs md:text-sm font-mono text-foreground">{item?.icdCode}</span>
                </div>
              )}
              
              <p className="text-sm md:text-base text-muted-foreground mb-3 line-clamp-3">
                {item?.description}
              </p>
              
              <div className="flex flex-wrap items-center gap-3 md:gap-4 text-xs md:text-sm text-muted-foreground">
                {item?.provider && (
                  <div className="flex items-center gap-1.5">
                    <Icon name="User" size={14} />
                    <span>{item?.provider}</span>
                  </div>
                )}
                {item?.status && (
                  <div className="flex items-center gap-1.5">
                    <div className={`w-2 h-2 rounded-full ${
                      item?.status === 'Active' ? 'bg-success' : 
                      item?.status === 'Resolved' ? 'bg-muted-foreground' : 
                      'bg-warning'
                    }`} />
                    <span>{item?.status}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MedicalHistorySection;